import { render, staticRenderFns } from "./manage-searches.vue?vue&type=template&id=12394996&scoped=true&"
import script from "./manage-searches.vue?vue&type=script&lang=js&"
export * from "./manage-searches.vue?vue&type=script&lang=js&"
import style0 from "./manage-searches.vue?vue&type=style&index=0&id=12394996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12394996",
  null
  
)

export default component.exports